import { NotificationSettings, useGetApiNotificationSettingsList, useGetApiWorkspaceGet, usePostApiNotificationSettingsCreate, usePostApiNotificationSettingsImport } from "@/API";
import { AppBreadcrumbs } from "@/Components/AppBreadcrumbs";
import { Button, Group } from "@mantine/core";
import { useParams } from "@tanstack/react-router";
import { NotificationSettingsEditButton } from "./NotificationSettingsEditButton";
import { useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import { NotificationSettingsCard } from "./NotificationSettingsCard";
import { AutoResetFileButton } from "@/Components/AutoResetFileButton";
import { modals } from "@mantine/modals";
import { useState } from "react";
import { IconBrandLine, IconFileImport, IconBellRinging } from "@tabler/icons-react";

export function NotificationSettingsIndex() {
    const { workspaceId } = useParams({ from: "/workspace/$workspaceId/notificationSettings/" })
    const queryClient = useQueryClient()
    const workspace = useGetApiWorkspaceGet({ id: workspaceId })
    const list = useGetApiNotificationSettingsList({ workspaceId: workspaceId })
    const [createLoading, setCreateLoading] = useState(false)
    const create_Mutation = usePostApiNotificationSettingsCreate()
    const import_Mutation = usePostApiNotificationSettingsImport()
    return <>
        <AppBreadcrumbs
            items={[
                {
                    label: '工作空間列表',
                    linkProps: { to: '/workspace' },
                },
                {
                    label: workspace.data?.data.name ?? '',
                    linkProps: { to: '/workspace/$workspaceId', params: { workspaceId } },
                },
                {
                    label: '通知設定',
                    active: true,
                }
            ]}
        />
        <Group>
            <NotificationSettingsEditButton workspaceId={workspaceId} onChange={async (v) => {
                setCreateLoading(true)
                try {
                    v.id = ""
                    v.workspaceId = workspaceId
                    await create_Mutation.mutateAsync({ params: { workspaceId: workspaceId }, data: v })
                    queryClient.invalidateQueries({ queryKey: list.queryKey })
                    notifications.show({ message: "新增成功" })
                } catch (e) {
                    notifications.show({ message: "新增失敗", color: "red" })
                }
                setCreateLoading(false)
            }}>
                <Button leftSection={<IconBellRinging />}>
                    新增通知
                </Button>
            </NotificationSettingsEditButton>
            <AutoResetFileButton accept="application/json" onChange={async f => {
                const text = await f?.text()
                if (text) {
                    const data = JSON.parse(text) as NotificationSettings
                    modals.openContextModal({
                        modal: "TextInput",
                        title: "匯入通知設定",
                        innerProps: {
                            initText: data.name ?? "",
                            children: <>匯入類別:{data.type}</>,
                            textInputProps: {
                                label: "名稱"
                            },
                            onConfirm: async v => {
                                setCreateLoading(true)
                                data.name = v
                                try {
                                    await import_Mutation.mutateAsync({
                                        params: {
                                            workspaceId: workspaceId
                                        },
                                        data: {
                                            importData: data
                                        }
                                    })
                                    queryClient.invalidateQueries({ queryKey: list.queryKey })
                                    notifications.show({ message: "匯入成功" })
                                } catch (e) {
                                    notifications.show({ message: "匯入失敗", color: "red" })
                                }
                                setCreateLoading(false)
                            }
                        }
                    })
                } else {
                    notifications.show({ message: "讀取資料失敗", color: "red" })
                }
            }}>
                {(props) => <Button {...props} loading={createLoading} leftSection={<IconFileImport />}>
                    匯入
                </Button>}
            </AutoResetFileButton>
        </Group>

        <Group mt="md">
            {list.data?.data.map((x, idx) => <NotificationSettingsCard key={idx} data={x} />)}
        </Group>
    </>
}